export default __webpack_public_path__ + "static/media/announcement_3@3x.dd078826.png";